const ConstantPermissions = {
  ADMIN_ACCESS_USER: 1,
  ADMIN_ACCESS_USER_CHANGE_PASSWORD: 7,
  ADMIN_ACCESS_USER_CLEAR_SESSION: 5,
  ADMIN_ACCESS_USER_DEACTIVATE: 3,
  ADMIN_ACCESS_USER_IMPERSONATE: 6,
  ADMIN_ACCESS_USER_LIST: 2,
  ADMIN_ACCESS_USER_REACTIVATE: 4,
  BASE_ADDRESSES: 17,
  BASE_ADDRESSES_DELETED: 18,
  BASE_ADDRESSES_DESTROY: 25,
  BASE_ADDRESSES_INDEX: 21,
  BASE_ADDRESSES_LOCKED_UPDATE: 31295,
  BASE_ADDRESSES_PURGE: 20,
  BASE_ADDRESSES_RESTORE: 19,
  BASE_ADDRESSES_ROUTE_BY_LAT_LNG: 1016,
  BASE_ADDRESSES_SHOW: 23,
  BASE_ADDRESSES_STORE: 22,
  BASE_ADDRESSES_UPDATE: 24,
  BASE_ADDRESSES_UPDATE_LAT_LNG: 31268,
  BASE_BANKS: 296,
  BASE_BANKS_DELETED: 297,
  BASE_BANKS_DESTROY: 304,
  BASE_BANKS_INDEX: 300,
  BASE_BANKS_PURGE: 299,
  BASE_BANKS_RESTORE: 298,
  BASE_BANKS_SHOW: 302,
  BASE_BANKS_STORE: 301,
  BASE_BANKS_UPDATE: 303,
  BASE_BUREAUS: 26,
  BASE_BUREAUS_DELETED: 27,
  BASE_BUREAUS_DESTROY: 34,
  BASE_BUREAUS_INDEX: 30,
  BASE_BUREAUS_PURGE: 29,
  BASE_BUREAUS_RESTORE: 28,
  BASE_BUREAUS_SHOW: 32,
  BASE_BUREAUS_STORE: 31,
  BASE_BUREAUS_UPDATE: 33,
  BASE_BUSINESS_LINES: 35,
  BASE_BUSINESS_LINES_DELETED: 36,
  BASE_BUSINESS_LINES_DESTROY: 43,
  BASE_BUSINESS_LINES_INDEX: 39,
  BASE_BUSINESS_LINES_PURGE: 38,
  BASE_BUSINESS_LINES_RESTORE: 37,
  BASE_BUSINESS_LINES_SHOW: 41,
  BASE_BUSINESS_LINES_STORE: 40,
  BASE_BUSINESS_LINES_UPDATE: 42,
  BASE_BUSINESS_PARTNER_CONTACTS: 53,
  BASE_BUSINESS_PARTNER_CONTACTS_DELETED: 54,
  BASE_BUSINESS_PARTNER_CONTACTS_DESTROY: 61,
  BASE_BUSINESS_PARTNER_CONTACTS_INDEX: 57,
  BASE_BUSINESS_PARTNER_CONTACTS_PURGE: 56,
  BASE_BUSINESS_PARTNER_CONTACTS_RESTORE: 55,
  BASE_BUSINESS_PARTNER_CONTACTS_SHOW: 59,
  BASE_BUSINESS_PARTNER_CONTACTS_STORE: 58,
  BASE_BUSINESS_PARTNER_CONTACTS_UPDATE: 60,
  BASE_BUSINESS_PARTNERS: 44,
  BASE_BUSINESS_PARTNERS_ACCOUNTING_CREDIT_LINE_SHOW: 31167,
  BASE_BUSINESS_PARTNERS_ACCOUNTING_CREDIT_LINE_UPDATE: 31168,
  BASE_BUSINESS_PARTNERS_ACCOUNTING_SHOW: 1019,
  BASE_BUSINESS_PARTNERS_ACCOUNTING_UPDATE: 1020,
  BASE_BUSINESS_PARTNERS_ADDRESS_BUSINESS_LINE_ADD: 1025,
  BASE_BUSINESS_PARTNERS_ADDRESS_BUSINESS_LINE_REMOVE: 11137,
  BASE_BUSINESS_PARTNERS_ADDRESS_BUSINESS_LINE_SHOW: 1024,
  BASE_BUSINESS_PARTNERS_ADDRESS_SHOW: 1021,
  BASE_BUSINESS_PARTNERS_ADDRESS_STORE: 1022,
  BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE: 1023,
  BASE_BUSINESS_PARTNERS_BUREAU_INDEX: 1030,
  BASE_BUSINESS_PARTNERS_BUREAU_SHOW: 1031,
  BASE_BUSINESS_PARTNERS_BUREAU_UPDATE: 1032,
  BASE_BUSINESS_PARTNERS_CONTACT_DELETED: 1029,
  BASE_BUSINESS_PARTNERS_CONTACT_SHOW: 1026,
  BASE_BUSINESS_PARTNERS_CONTACT_STORE: 1027,
  BASE_BUSINESS_PARTNERS_CONTACT_UPDATE: 1028,
  BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX: 31164,
  BASE_BUSINESS_PARTNERS_CXC_INDEX: 1039,
  BASE_BUSINESS_PARTNERS_CXC_SHOW: 1040,
  BASE_BUSINESS_PARTNERS_DELETED: 45,
  BASE_BUSINESS_PARTNERS_DESTROY: 52,
  BASE_BUSINESS_PARTNERS_DOCUMENT_INDEX: 1033,
  BASE_BUSINESS_PARTNERS_DOCUMENT_SHOW: 1034,
  BASE_BUSINESS_PARTNERS_INDEX: 48,
  BASE_BUSINESS_PARTNERS_NC_INDEX: 1043,
  BASE_BUSINESS_PARTNERS_NC_SHOW: 1044,
  BASE_BUSINESS_PARTNERS_ORDER_INDEX: 1035,
  BASE_BUSINESS_PARTNERS_ORDER_SAP_INDEX: 1037,
  BASE_BUSINESS_PARTNERS_ORDER_SAP_SHOW: 1038,
  BASE_BUSINESS_PARTNERS_ORDER_SHOW: 1036,
  BASE_BUSINESS_PARTNERS_PROVIDER_ACCOUNTING_SHOW: 1047,
  BASE_BUSINESS_PARTNERS_PROVIDER_ACCOUNTING_UPDATE: 1048,
  BASE_BUSINESS_PARTNERS_PROVIDER_ADDRESS_BUSINESS_LINE_ADD: 1053,
  BASE_BUSINESS_PARTNERS_PROVIDER_ADDRESS_BUSINESS_LINE_SHOW: 1052,
  BASE_BUSINESS_PARTNERS_PROVIDER_ADDRESS_SHOW: 1049,
  BASE_BUSINESS_PARTNERS_PROVIDER_ADDRESS_STORE: 1050,
  BASE_BUSINESS_PARTNERS_PROVIDER_ADDRESS_UPDATE: 1051,
  BASE_BUSINESS_PARTNERS_PROVIDER_CONTACT_DELETED: 1057,
  BASE_BUSINESS_PARTNERS_PROVIDER_CONTACT_SHOW: 1054,
  BASE_BUSINESS_PARTNERS_PROVIDER_CONTACT_STORE: 1055,
  BASE_BUSINESS_PARTNERS_PROVIDER_CONTACT_UPDATE: 1056,
  BASE_BUSINESS_PARTNERS_PROVIDER_CXP_INDEX: 1060,
  BASE_BUSINESS_PARTNERS_PROVIDER_CXP_SHOW: 1061,
  BASE_BUSINESS_PARTNERS_PROVIDER_DOCUMENT_INDEX: 1058,
  BASE_BUSINESS_PARTNERS_PROVIDER_DOCUMENT_SHOW: 1059,
  BASE_BUSINESS_PARTNERS_PROVIDER_INDEX: 31162,
  BASE_BUSINESS_PARTNERS_PROVIDER_MARK_SHOW: 31165,
  BASE_BUSINESS_PARTNERS_PROVIDER_NC_INDEX: 1064,
  BASE_BUSINESS_PARTNERS_PROVIDER_NC_SHOW: 1065,
  BASE_BUSINESS_PARTNERS_PROVIDER_SALE_INDEX: 1062,
  BASE_BUSINESS_PARTNERS_PROVIDER_SALE_SHOW: 1063,
  BASE_BUSINESS_PARTNERS_PROVIDER_SUMMARY_SHOW: 1045,
  BASE_BUSINESS_PARTNERS_PROVIDER_SUMMARY_UPDATE: 1046,
  BASE_BUSINESS_PARTNERS_PURGE: 47,
  BASE_BUSINESS_PARTNERS_RESTORE: 46,
  BASE_BUSINESS_PARTNERS_SALE_INDEX: 1041,
  BASE_BUSINESS_PARTNERS_SALE_SHOW: 1042,
  BASE_BUSINESS_PARTNERS_SHOW: 50,
  BASE_BUSINESS_PARTNERS_STORE: 49,
  BASE_BUSINESS_PARTNERS_SUMMARY_SHOW: 1017,
  BASE_BUSINESS_PARTNERS_SUMMARY_UPDATE: 1018,
  BASE_BUSINESS_PARTNERS_UPDATE: 51,
  BASE_CANALS: 62,
  BASE_CANALS_DELETED: 63,
  BASE_CANALS_DESTROY: 70,
  BASE_CANALS_INDEX: 66,
  BASE_CANALS_PURGE: 65,
  BASE_CANALS_RESTORE: 64,
  BASE_CANALS_SHOW: 68,
  BASE_CANALS_STORE: 67,
  BASE_CANALS_UPDATE: 69,
  BASE_CONFIGURATIONS: 31139,
  BASE_CONFIGURATIONS_DELETED: 31140,
  BASE_CONFIGURATIONS_DESTROY: 31146,
  BASE_CONFIGURATIONS_INDEX: 31143,
  BASE_CONFIGURATIONS_PURGE: 31142,
  BASE_CONFIGURATIONS_RESTORE: 31141,
  BASE_CONFIGURATIONS_SHOW: 31145,
  BASE_CONFIGURATIONS_STORE: 31144,
  BASE_CONFIGURATIONS_UPDATE: 31163,
  BASE_COUNTRIES: 305,
  BASE_COUNTRIES_DELETED: 306,
  BASE_COUNTRIES_DESTROY: 313,
  BASE_COUNTRIES_INDEX: 309,
  BASE_COUNTRIES_PURGE: 308,
  BASE_COUNTRIES_RESTORE: 307,
  BASE_COUNTRIES_SHOW: 311,
  BASE_COUNTRIES_STORE: 310,
  BASE_COUNTRIES_UPDATE: 312,
  BASE_CURRENCIES: 71,
  BASE_CURRENCIES_DELETED: 72,
  BASE_CURRENCIES_DESTROY: 79,
  BASE_CURRENCIES_INDEX: 75,
  BASE_CURRENCIES_PURGE: 74,
  BASE_CURRENCIES_RESTORE: 73,
  BASE_CURRENCIES_SHOW: 77,
  BASE_CURRENCIES_STORE: 76,
  BASE_CURRENCIES_UPDATE: 78,
  BASE_CUSTOMER_BUREAUS: 80,
  BASE_CUSTOMER_BUREAUS_DELETED: 81,
  BASE_CUSTOMER_BUREAUS_DESTROY: 88,
  BASE_CUSTOMER_BUREAUS_INDEX: 84,
  BASE_CUSTOMER_BUREAUS_PURGE: 83,
  BASE_CUSTOMER_BUREAUS_RESTORE: 82,
  BASE_CUSTOMER_BUREAUS_SHOW: 86,
  BASE_CUSTOMER_BUREAUS_STORE: 85,
  BASE_CUSTOMER_BUREAUS_UPDATE: 87,
  BASE_CUSTOMER_GROUPS: 89,
  BASE_CUSTOMER_GROUPS_DELETED: 90,
  BASE_CUSTOMER_GROUPS_DESTROY: 97,
  BASE_CUSTOMER_GROUPS_INDEX: 93,
  BASE_CUSTOMER_GROUPS_PURGE: 92,
  BASE_CUSTOMER_GROUPS_RESTORE: 91,
  BASE_CUSTOMER_GROUPS_SHOW: 95,
  BASE_CUSTOMER_GROUPS_STORE: 94,
  BASE_CUSTOMER_GROUPS_UPDATE: 96,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS: 98,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_ADD_DAILY_PORTFOLIO: 1068,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_DELETED: 99,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_DESTROY: 106,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_EXCHANGE_SELLER: 1066,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_INDEX: 102,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_PURGE: 101,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_RESTORE: 100,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_SET_SELLER: 1067,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_SHOW: 104,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_STORE: 103,
  BASE_CUSTOMER_PORTFOLIO_BUREAUS_UPDATE: 105,
  BASE_CUSTOMER_PORTFOLIOS: 107,
  BASE_CUSTOMER_PORTFOLIOS_DELETED: 108,
  BASE_CUSTOMER_PORTFOLIOS_DESTROY: 115,
  BASE_CUSTOMER_PORTFOLIOS_INDEX: 111,
  BASE_CUSTOMER_PORTFOLIOS_PURGE: 110,
  BASE_CUSTOMER_PORTFOLIOS_RESTORE: 109,
  BASE_CUSTOMER_PORTFOLIOS_SHOW: 113,
  BASE_CUSTOMER_PORTFOLIOS_STORE: 112,
  BASE_CUSTOMER_PORTFOLIOS_UPDATE: 114,
  BASE_CUSTOMER_ROUTES: 116,
  BASE_CUSTOMER_ROUTES_DELETED: 117,
  BASE_CUSTOMER_ROUTES_DESTROY: 124,
  BASE_CUSTOMER_ROUTES_INDEX: 120,
  BASE_CUSTOMER_ROUTES_MARKED_OF_DAY: 1070,
  BASE_CUSTOMER_ROUTES_MARKED_OF_DAY_DETAIL: 1071,
  BASE_CUSTOMER_ROUTES_MARKED_POINTS: 1069,
  BASE_CUSTOMER_ROUTES_PURGE: 119,
  BASE_CUSTOMER_ROUTES_RESTORE: 118,
  BASE_CUSTOMER_ROUTES_SHOW: 122,
  BASE_CUSTOMER_ROUTES_STORE: 121,
  BASE_CUSTOMER_ROUTES_UPDATE: 123,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS: 134,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_DELETED: 135,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_DESTROY: 142,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_INDEX: 138,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_PURGE: 137,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_RESTORE: 136,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_SHOW: 140,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_STORE: 139,
  BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_UPDATE: 141,
  BASE_DAILY_CUSTOMER_PORTFOLIOS: 125,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_DELETED: 126,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_DESTROY: 133,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_INDEX: 129,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_PURGE: 128,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_RESTORE: 127,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_SHOW: 131,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_STORE: 130,
  BASE_DAILY_CUSTOMER_PORTFOLIOS_UPDATE: 132,
  BASE_DETRACTIONS: 314,
  BASE_DETRACTIONS_DELETED: 315,
  BASE_DETRACTIONS_DESTROY: 322,
  BASE_DETRACTIONS_INDEX: 318,
  BASE_DETRACTIONS_PURGE: 317,
  BASE_DETRACTIONS_RESTORE: 316,
  BASE_DETRACTIONS_SHOW: 320,
  BASE_DETRACTIONS_STORE: 319,
  BASE_DETRACTIONS_UPDATE: 321,
  BASE_DOCUMENT_TYPES: 143,
  BASE_DOCUMENT_TYPES_DELETED: 144,
  BASE_DOCUMENT_TYPES_DESTROY: 151,
  BASE_DOCUMENT_TYPES_INDEX: 147,
  BASE_DOCUMENT_TYPES_PURGE: 146,
  BASE_DOCUMENT_TYPES_RESTORE: 145,
  BASE_DOCUMENT_TYPES_SHOW: 149,
  BASE_DOCUMENT_TYPES_STORE: 148,
  BASE_DOCUMENT_TYPES_UPDATE: 150,
  BASE_EMPLOYEE_POSITIONS: 152,
  BASE_EMPLOYEE_POSITIONS_DELETED: 153,
  BASE_EMPLOYEE_POSITIONS_DESTROY: 160,
  BASE_EMPLOYEE_POSITIONS_INDEX: 156,
  BASE_EMPLOYEE_POSITIONS_PURGE: 155,
  BASE_EMPLOYEE_POSITIONS_RESTORE: 154,
  BASE_EMPLOYEE_POSITIONS_SHOW: 158,
  BASE_EMPLOYEE_POSITIONS_STORE: 157,
  BASE_EMPLOYEE_POSITIONS_UPDATE: 159,
  BASE_EMPLOYEE_STATUSES: 161,
  BASE_EMPLOYEE_STATUSES_DELETED: 162,
  BASE_EMPLOYEE_STATUSES_DESTROY: 169,
  BASE_EMPLOYEE_STATUSES_INDEX: 165,
  BASE_EMPLOYEE_STATUSES_PURGE: 164,
  BASE_EMPLOYEE_STATUSES_RESTORE: 163,
  BASE_EMPLOYEE_STATUSES_SHOW: 167,
  BASE_EMPLOYEE_STATUSES_STORE: 166,
  BASE_EMPLOYEE_STATUSES_UPDATE: 168,
  BASE_FURNITURES: 31372,
  BASE_FURNITURES_DELETED: 31373,
  BASE_FURNITURES_DESTROY: 31380,
  BASE_FURNITURES_INDEX: 31376,
  BASE_FURNITURES_PURGE: 31375,
  BASE_FURNITURES_RESTORE: 31374,
  BASE_FURNITURES_SHOW: 31378,
  BASE_FURNITURES_STORE: 31377,
  BASE_FURNITURES_UPDATE: 31379,
  BASE_HOLIDAYS: 683,
  BASE_HOLIDAYS_DELETED: 684,
  BASE_HOLIDAYS_DESTROY: 691,
  BASE_HOLIDAYS_INDEX: 687,
  BASE_HOLIDAYS_PURGE: 686,
  BASE_HOLIDAYS_RESTORE: 685,
  BASE_HOLIDAYS_SHOW: 689,
  BASE_HOLIDAYS_STORE: 688,
  BASE_HOLIDAYS_UPDATE: 690,
  BASE_LAYERS: 31291,
  BASE_LAYERS_DESTROY: 31294,
  BASE_LAYERS_STORE: 31292,
  BASE_LAYERS_UPDATE: 31293,
  BASE_LOGS: 674,
  BASE_LOGS_DELETED: 675,
  BASE_LOGS_DESTROY: 682,
  BASE_LOGS_INDEX: 678,
  BASE_LOGS_PURGE: 677,
  BASE_LOGS_RESTORE: 676,
  BASE_LOGS_SHOW: 680,
  BASE_LOGS_STORE: 679,
  BASE_LOGS_UPDATE: 681,
  BASE_PAYMENT_TERMS: 170,
  BASE_PAYMENT_TERMS_DELETED: 171,
  BASE_PAYMENT_TERMS_DESTROY: 178,
  BASE_PAYMENT_TERMS_INDEX: 174,
  BASE_PAYMENT_TERMS_PURGE: 173,
  BASE_PAYMENT_TERMS_RESTORE: 172,
  BASE_PAYMENT_TERMS_SHOW: 176,
  BASE_PAYMENT_TERMS_STORE: 175,
  BASE_PAYMENT_TERMS_UPDATE: 177,
  BASE_PERSON_TYPES: 179,
  BASE_PERSON_TYPES_DELETED: 180,
  BASE_PERSON_TYPES_DESTROY: 187,
  BASE_PERSON_TYPES_INDEX: 183,
  BASE_PERSON_TYPES_PURGE: 182,
  BASE_PERSON_TYPES_RESTORE: 181,
  BASE_PERSON_TYPES_SHOW: 185,
  BASE_PERSON_TYPES_STORE: 184,
  BASE_PERSON_TYPES_UPDATE: 186,
  BASE_QUOTAS: 188,
  BASE_QUOTAS_DELETED: 189,
  BASE_QUOTAS_DESTROY: 196,
  BASE_QUOTAS_INDEX: 192,
  BASE_QUOTAS_MARK_GROUPED: 1073,
  BASE_QUOTAS_MARK_GROUPED_DETAIL: 1074,
  BASE_QUOTAS_MASSIVE_UPDATE: 1072,
  BASE_QUOTAS_PURGE: 191,
  BASE_QUOTAS_RESTORE: 190,
  BASE_QUOTAS_SELLER_GROUPED: 1075,
  BASE_QUOTAS_SELLER_GROUPED_DETAIL: 1076,
  BASE_QUOTAS_SHOW: 194,
  BASE_QUOTAS_STORE: 193,
  BASE_QUOTAS_UPDATE: 195,
  BASE_REASONS: 197,
  BASE_REASONS_DELETED: 198,
  BASE_REASONS_DESTROY: 205,
  BASE_REASONS_INDEX: 201,
  BASE_REASONS_PURGE: 200,
  BASE_REASONS_RESTORE: 199,
  BASE_REASONS_SHOW: 203,
  BASE_REASONS_STORE: 202,
  BASE_REASONS_UPDATE: 204,
  BASE_ROUTES: 206,
  BASE_ROUTES_ADDRESSES: 1077,
  BASE_ROUTES_DELETED: 207,
  BASE_ROUTES_DESTROY: 214,
  BASE_ROUTES_FREIGHT_RATE: 31262,
  BASE_ROUTES_INDEX: 210,
  BASE_ROUTES_LOCKED_UPDATE: 31296,
  BASE_ROUTES_POLYGON_SHOW: 1079,
  BASE_ROUTES_POLYGON_UPDATE: 1080,
  BASE_ROUTES_PURGE: 209,
  BASE_ROUTES_RESTORE: 208,
  BASE_ROUTES_SHOW: 212,
  BASE_ROUTES_STORE: 211,
  BASE_ROUTES_UPDATE: 213,
  BASE_ROUTES_WITH_ORDERS: 1078,
  BASE_SALE_FORCE_CANALS: 224,
  BASE_SALE_FORCE_CANALS_DELETED: 225,
  BASE_SALE_FORCE_CANALS_DESTROY: 232,
  BASE_SALE_FORCE_CANALS_INDEX: 228,
  BASE_SALE_FORCE_CANALS_PURGE: 227,
  BASE_SALE_FORCE_CANALS_RESTORE: 226,
  BASE_SALE_FORCE_CANALS_SHOW: 230,
  BASE_SALE_FORCE_CANALS_STORE: 229,
  BASE_SALE_FORCE_CANALS_UPDATE: 231,
  BASE_SALE_FORCE_DETAILS: 233,
  BASE_SALE_FORCE_DETAILS_DELETED: 234,
  BASE_SALE_FORCE_DETAILS_DESTROY: 241,
  BASE_SALE_FORCE_DETAILS_INDEX: 237,
  BASE_SALE_FORCE_DETAILS_PURGE: 236,
  BASE_SALE_FORCE_DETAILS_RESTORE: 235,
  BASE_SALE_FORCE_DETAILS_SHOW: 239,
  BASE_SALE_FORCE_DETAILS_STORE: 238,
  BASE_SALE_FORCE_DETAILS_UPDATE: 240,
  BASE_SALE_FORCES: 215,
  BASE_SALE_FORCES_DELETED: 216,
  BASE_SALE_FORCES_DESTROY: 223,
  BASE_SALE_FORCES_INDEX: 219,
  BASE_SALE_FORCES_PURGE: 218,
  BASE_SALE_FORCES_RESTORE: 217,
  BASE_SALE_FORCES_SHOW: 221,
  BASE_SALE_FORCES_STORE: 220,
  BASE_SALE_FORCES_UPDATE: 222,
  BASE_SELLERS: 242,
  BASE_SELLERS_DELETED: 243,
  BASE_SELLERS_DESTROY: 250,
  BASE_SELLERS_INDEX: 246,
  BASE_SELLERS_PURGE: 245,
  BASE_SELLERS_QUOTA_INDEX: 1081,
  BASE_SELLERS_QUOTA_SHOW: 1082,
  BASE_SELLERS_RESTORE: 244,
  BASE_SELLERS_SHOW: 248,
  BASE_SELLERS_STORE: 247,
  BASE_SELLERS_UPDATE: 249,
  BASE_STATES: 251,
  BASE_STATES_DELETED: 252,
  BASE_STATES_DESTROY: 259,
  BASE_STATES_INDEX: 255,
  BASE_STATES_PURGE: 254,
  BASE_STATES_RESTORE: 253,
  BASE_STATES_SHOW: 257,
  BASE_STATES_STORE: 256,
  BASE_STATES_UPDATE: 258,
  BASE_SUNAT_DOCUMENT_TYPES: 260,
  BASE_SUNAT_DOCUMENT_TYPES_DELETED: 261,
  BASE_SUNAT_DOCUMENT_TYPES_DESTROY: 268,
  BASE_SUNAT_DOCUMENT_TYPES_INDEX: 264,
  BASE_SUNAT_DOCUMENT_TYPES_PURGE: 263,
  BASE_SUNAT_DOCUMENT_TYPES_RESTORE: 262,
  BASE_SUNAT_DOCUMENT_TYPES_SHOW: 266,
  BASE_SUNAT_DOCUMENT_TYPES_STORE: 265,
  BASE_SUNAT_DOCUMENT_TYPES_UPDATE: 267,
  BASE_SUPERVISORS: 701,
  BASE_SUPERVISORS_DELETED: 702,
  BASE_SUPERVISORS_DESTROY: 709,
  BASE_SUPERVISORS_INDEX: 705,
  BASE_SUPERVISORS_PURGE: 704,
  BASE_SUPERVISORS_RESTORE: 703,
  BASE_SUPERVISORS_SHOW: 707,
  BASE_SUPERVISORS_STORE: 706,
  BASE_SUPERVISORS_UPDATE: 708,
  BASE_TAXES: 269,
  BASE_TAXES_DELETED: 270,
  BASE_TAXES_DESTROY: 277,
  BASE_TAXES_INDEX: 273,
  BASE_TAXES_PURGE: 272,
  BASE_TAXES_RESTORE: 271,
  BASE_TAXES_SHOW: 275,
  BASE_TAXES_STORE: 274,
  BASE_TAXES_UPDATE: 276,
  BASE_UBIGEOS: 278,
  BASE_UBIGEOS_DELETED: 279,
  BASE_UBIGEOS_DESTROY: 286,
  BASE_UBIGEOS_INDEX: 282,
  BASE_UBIGEOS_PURGE: 281,
  BASE_UBIGEOS_RESTORE: 280,
  BASE_UBIGEOS_SHOW: 284,
  BASE_UBIGEOS_STORE: 283,
  BASE_UBIGEOS_UPDATE: 285,
  BASE_VISIT_DAYS: 287,
  BASE_VISIT_DAYS_DELETED: 288,
  BASE_VISIT_DAYS_DESTROY: 295,
  BASE_VISIT_DAYS_INDEX: 291,
  BASE_VISIT_DAYS_PURGE: 290,
  BASE_VISIT_DAYS_RESTORE: 289,
  BASE_VISIT_DAYS_SHOW: 293,
  BASE_VISIT_DAYS_STORE: 292,
  BASE_VISIT_DAYS_UPDATE: 294,
  BASE_ZONES: 692,
  BASE_ZONES_DELETED: 693,
  BASE_ZONES_DESTROY: 700,
  BASE_ZONES_INDEX: 696,
  BASE_ZONES_PURGE: 695,
  BASE_ZONES_RESTORE: 694,
  BASE_ZONES_SHOW: 698,
  BASE_ZONES_STORE: 697,
  BASE_ZONES_UPDATE: 699,
  COM_RANGES: 31172,
  COM_RANGES_DELETED: 31173,
  COM_RANGES_DESTROY: 31180,
  COM_RANGES_INDEX: 31176,
  COM_RANGES_PURGE: 31175,
  COM_RANGES_RESTORE: 31174,
  COM_RANGES_SHOW: 31178,
  COM_RANGES_STORE: 31177,
  COM_RANGES_UPDATE: 31179,
  COM_ZONE_QUOTAS: 31199,
  COM_ZONE_QUOTAS_DELETED: 31200,
  COM_ZONE_QUOTAS_DESTROY: 31207,
  COM_ZONE_QUOTAS_INDEX: 31203,
  COM_ZONE_QUOTAS_PURGE: 31202,
  COM_ZONE_QUOTAS_RESTORE: 31201,
  COM_ZONE_QUOTAS_SHOW: 31205,
  COM_ZONE_QUOTAS_STORE: 31204,
  COM_ZONE_QUOTAS_UPDATE: 31206,
  DEFAULT: 8,
  DEFAULT_DELETED: 9,
  DEFAULT_DESTROY: 16,
  DEFAULT_INDEX: 12,
  DEFAULT_PURGE: 11,
  DEFAULT_RESTORE: 10,
  DEFAULT_SHOW: 14,
  DEFAULT_STORE: 13,
  DEFAULT_UPDATE: 15,
  DELIV_DOCUMENTS: 890,
  DELIV_DOCUMENTS_DELETED: 891,
  DELIV_DOCUMENTS_DESTROY: 898,
  DELIV_DOCUMENTS_INDEX: 894,
  DELIV_DOCUMENTS_PURGE: 893,
  DELIV_DOCUMENTS_RESTORE: 892,
  DELIV_DOCUMENTS_SHOW: 896,
  DELIV_DOCUMENTS_STORE: 895,
  DELIV_DOCUMENTS_UPDATE: 897,
  DELIV_JORNADAS: 31159,
  DELIV_JORNADAS_INDEX: 31160,
  DELIV_JORNADAS_INICIAR_JORNADA: 31161,
  DELIV_LINES: 899,
  DELIV_LINES_DELETED: 900,
  DELIV_LINES_DESTROY: 907,
  DELIV_LINES_INDEX: 903,
  DELIV_LINES_PURGE: 902,
  DELIV_LINES_RESTORE: 901,
  DELIV_LINES_SHOW: 905,
  DELIV_LINES_STORE: 904,
  DELIV_LINES_UPDATE: 906,
  DELIV_MOTIVOS: 908,
  DELIV_MOTIVOS_DELETED: 909,
  DELIV_MOTIVOS_DESTROY: 916,
  DELIV_MOTIVOS_INDEX: 912,
  DELIV_MOTIVOS_PURGE: 911,
  DELIV_MOTIVOS_RESTORE: 910,
  DELIV_MOTIVOS_SHOW: 914,
  DELIV_MOTIVOS_STORE: 913,
  DELIV_MOTIVOS_UPDATE: 915,
  DELIV_SHEET_DISTRIBUTIONS: 926,
  DELIV_SHEET_DISTRIBUTIONS_DELETED: 927,
  DELIV_SHEET_DISTRIBUTIONS_DESTROY: 934,
  DELIV_SHEET_DISTRIBUTIONS_INDEX: 930,
  DELIV_SHEET_DISTRIBUTIONS_PURGE: 929,
  DELIV_SHEET_DISTRIBUTIONS_RESTORE: 928,
  DELIV_SHEET_DISTRIBUTIONS_SHOW: 932,
  DELIV_SHEET_DISTRIBUTIONS_STORE: 931,
  DELIV_SHEET_DISTRIBUTIONS_UPDATE: 933,
  DELIV_USUARIOS: 917,
  DELIV_USUARIOS_DELETED: 918,
  DELIV_USUARIOS_DESTROY: 925,
  DELIV_USUARIOS_INDEX: 921,
  DELIV_USUARIOS_PURGE: 920,
  DELIV_USUARIOS_RESTORE: 919,
  DELIV_USUARIOS_SHOW: 923,
  DELIV_USUARIOS_STORE: 922,
  DELIV_USUARIOS_UPDATE: 924,
  INCENTIVOS_TIPO_INCENTIVOS: 31321,
  INCENTIVOS_TIPO_INCENTIVOS_DELETED: 31322,
  INCENTIVOS_TIPO_INCENTIVOS_DESTROY: 31329,
  INCENTIVOS_TIPO_INCENTIVOS_INDEX: 31325,
  INCENTIVOS_TIPO_INCENTIVOS_PURGE: 31324,
  INCENTIVOS_TIPO_INCENTIVOS_RESTORE: 31323,
  INCENTIVOS_TIPO_INCENTIVOS_SHOW: 31327,
  INCENTIVOS_TIPO_INCENTIVOS_STORE: 31326,
  INCENTIVOS_TIPO_INCENTIVOS_UPDATE: 31328,
  LOGI_CATEGORIES: 719,
  LOGI_CATEGORIES_DELETED: 720,
  LOGI_CATEGORIES_DESTROY: 727,
  LOGI_CATEGORIES_INDEX: 723,
  LOGI_CATEGORIES_PURGE: 722,
  LOGI_CATEGORIES_RESTORE: 721,
  LOGI_CATEGORIES_SHOW: 725,
  LOGI_CATEGORIES_STORE: 724,
  LOGI_CATEGORIES_UPDATE: 726,
  LOGI_CONVERTIONS: 31269,
  LOGI_CONVERTIONS_CONFIRM: 31287,
  LOGI_CONVERTIONS_DELETED: 31270,
  LOGI_CONVERTIONS_DESTROY: 31277,
  LOGI_CONVERTIONS_INDEX: 31273,
  LOGI_CONVERTIONS_PURGE: 31272,
  LOGI_CONVERTIONS_RESTORE: 31271,
  LOGI_CONVERTIONS_SHOW: 31275,
  LOGI_CONVERTIONS_STORE: 31274,
  LOGI_CONVERTIONS_UPDATE: 31276,
  LOGI_ENTRIES: 31208,
  LOGI_ENTRIES_CONFIRM: 31226,
  LOGI_ENTRIES_DELETED: 31209,
  LOGI_ENTRIES_DESTROY: 31216,
  LOGI_ENTRIES_INDEX: 31212,
  LOGI_ENTRIES_PURGE: 31211,
  LOGI_ENTRIES_RESTORE: 31210,
  LOGI_ENTRIES_SHOW: 31214,
  LOGI_ENTRIES_STORE: 31213,
  LOGI_ENTRIES_UPDATE: 31215,
  LOGI_EXISTENCE_CATALOGS: 728,
  LOGI_EXISTENCE_CATALOGS_DELETED: 729,
  LOGI_EXISTENCE_CATALOGS_DESTROY: 736,
  LOGI_EXISTENCE_CATALOGS_INDEX: 732,
  LOGI_EXISTENCE_CATALOGS_PURGE: 731,
  LOGI_EXISTENCE_CATALOGS_RESTORE: 730,
  LOGI_EXISTENCE_CATALOGS_SHOW: 734,
  LOGI_EXISTENCE_CATALOGS_STORE: 733,
  LOGI_EXISTENCE_CATALOGS_UPDATE: 735,
  LOGI_EXISTENCE_TYPES: 737,
  LOGI_EXISTENCE_TYPES_DELETED: 738,
  LOGI_EXISTENCE_TYPES_DESTROY: 745,
  LOGI_EXISTENCE_TYPES_INDEX: 741,
  LOGI_EXISTENCE_TYPES_PURGE: 740,
  LOGI_EXISTENCE_TYPES_RESTORE: 739,
  LOGI_EXISTENCE_TYPES_SHOW: 743,
  LOGI_EXISTENCE_TYPES_STORE: 742,
  LOGI_EXISTENCE_TYPES_UPDATE: 744,
  LOGI_FAMILIES: 746,
  LOGI_FAMILIES_DELETED: 747,
  LOGI_FAMILIES_DESTROY: 754,
  LOGI_FAMILIES_INDEX: 750,
  LOGI_FAMILIES_PURGE: 749,
  LOGI_FAMILIES_RESTORE: 748,
  LOGI_FAMILIES_SHOW: 752,
  LOGI_FAMILIES_STORE: 751,
  LOGI_FAMILIES_UPDATE: 753,
  LOGI_INVENTORIES: 31310,
  LOGI_INVENTORIES_DELETED: 31311,
  LOGI_INVENTORIES_DESTROY: 31318,
  LOGI_INVENTORIES_INDEX: 31314,
  LOGI_INVENTORIES_PURGE: 31313,
  LOGI_INVENTORIES_RESTORE: 31312,
  LOGI_INVENTORIES_SHOW: 31316,
  LOGI_INVENTORIES_STORE: 31315,
  LOGI_INVENTORIES_UPDATE: 31317,
  LOGI_LENGTH_UNITS: 755,
  LOGI_LENGTH_UNITS_DELETED: 756,
  LOGI_LENGTH_UNITS_DESTROY: 763,
  LOGI_LENGTH_UNITS_INDEX: 759,
  LOGI_LENGTH_UNITS_PURGE: 758,
  LOGI_LENGTH_UNITS_RESTORE: 757,
  LOGI_LENGTH_UNITS_SHOW: 761,
  LOGI_LENGTH_UNITS_STORE: 760,
  LOGI_LENGTH_UNITS_UPDATE: 762,
  LOGI_LINES: 764,
  LOGI_LINES_DELETED: 765,
  LOGI_LINES_DESTROY: 772,
  LOGI_LINES_INDEX: 768,
  LOGI_LINES_PURGE: 767,
  LOGI_LINES_RESTORE: 766,
  LOGI_LINES_SHOW: 770,
  LOGI_LINES_STORE: 769,
  LOGI_LINES_UPDATE: 771,
  LOGI_MANUFACTURERS: 773,
  LOGI_MANUFACTURERS_DELETED: 774,
  LOGI_MANUFACTURERS_DESTROY: 781,
  LOGI_MANUFACTURERS_INDEX: 777,
  LOGI_MANUFACTURERS_PURGE: 776,
  LOGI_MANUFACTURERS_RESTORE: 775,
  LOGI_MANUFACTURERS_SHOW: 779,
  LOGI_MANUFACTURERS_STORE: 778,
  LOGI_MANUFACTURERS_UPDATE: 780,
  LOGI_MARKS: 782,
  LOGI_MARKS_DELETED: 783,
  LOGI_MARKS_DESTROY: 790,
  LOGI_MARKS_INDEX: 786,
  LOGI_MARKS_PURGE: 785,
  LOGI_MARKS_QUOTA_INDEX: 1109,
  LOGI_MARKS_QUOTA_SHOW: 1110,
  LOGI_MARKS_RESTORE: 784,
  LOGI_MARKS_SHOW: 788,
  LOGI_MARKS_STORE: 787,
  LOGI_MARKS_UPDATE: 789,
  LOGI_MATERIAL_LISTS: 31278,
  LOGI_MATERIAL_LISTS_DELETED: 31279,
  LOGI_MATERIAL_LISTS_DESTROY: 31286,
  LOGI_MATERIAL_LISTS_INDEX: 31282,
  LOGI_MATERIAL_LISTS_PURGE: 31281,
  LOGI_MATERIAL_LISTS_RESTORE: 31280,
  LOGI_MATERIAL_LISTS_SHOW: 31284,
  LOGI_MATERIAL_LISTS_STORE: 31283,
  LOGI_MATERIAL_LISTS_UPDATE: 31285,
  LOGI_MEASURE_UNIT_TYPE: 11138,
  LOGI_MEASURE_UNIT_TYPE_DELETED: 11139,
  LOGI_MEASURE_UNIT_TYPE_DESTROY: 11146,
  LOGI_MEASURE_UNIT_TYPE_INDEX: 11142,
  LOGI_MEASURE_UNIT_TYPE_PURGE: 11141,
  LOGI_MEASURE_UNIT_TYPE_RESTORE: 11140,
  LOGI_MEASURE_UNIT_TYPE_SHOW: 11144,
  LOGI_MEASURE_UNIT_TYPE_STORE: 11143,
  LOGI_MEASURE_UNIT_TYPE_UPDATE: 11145,
  LOGI_MEASURE_UNIT_TYPES: 800,
  LOGI_MEASURE_UNIT_TYPES_DELETED: 801,
  LOGI_MEASURE_UNIT_TYPES_DESTROY: 808,
  LOGI_MEASURE_UNIT_TYPES_INDEX: 804,
  LOGI_MEASURE_UNIT_TYPES_PURGE: 803,
  LOGI_MEASURE_UNIT_TYPES_RESTORE: 802,
  LOGI_MEASURE_UNIT_TYPES_SHOW: 806,
  LOGI_MEASURE_UNIT_TYPES_STORE: 805,
  LOGI_MEASURE_UNIT_TYPES_UPDATE: 807,
  LOGI_MEASURE_UNITS: 791,
  LOGI_MEASURE_UNITS_DELETED: 792,
  LOGI_MEASURE_UNITS_DESTROY: 799,
  LOGI_MEASURE_UNITS_INDEX: 795,
  LOGI_MEASURE_UNITS_PURGE: 794,
  LOGI_MEASURE_UNITS_RESTORE: 793,
  LOGI_MEASURE_UNITS_SHOW: 797,
  LOGI_MEASURE_UNITS_STORE: 796,
  LOGI_MEASURE_UNITS_UPDATE: 798,
  LOGI_OUTPUTS: 31217,
  LOGI_OUTPUTS_CONFIRM: 31227,
  LOGI_OUTPUTS_DELETED: 31218,
  LOGI_OUTPUTS_DESTROY: 31225,
  LOGI_OUTPUTS_INDEX: 31221,
  LOGI_OUTPUTS_PURGE: 31220,
  LOGI_OUTPUTS_RESTORE: 31219,
  LOGI_OUTPUTS_SHOW: 31223,
  LOGI_OUTPUTS_STORE: 31222,
  LOGI_OUTPUTS_UPDATE: 31224,
  LOGI_PORTFOLIOS: 809,
  LOGI_PORTFOLIOS_DELETED: 810,
  LOGI_PORTFOLIOS_DESTROY: 817,
  LOGI_PORTFOLIOS_INDEX: 813,
  LOGI_PORTFOLIOS_PURGE: 812,
  LOGI_PORTFOLIOS_RESTORE: 811,
  LOGI_PORTFOLIOS_SHOW: 815,
  LOGI_PORTFOLIOS_STORE: 814,
  LOGI_PORTFOLIOS_UPDATE: 816,
  LOGI_PRICE_LISTS: 827,
  LOGI_PRICE_LISTS_DELETED: 828,
  LOGI_PRICE_LISTS_DESTROY: 835,
  LOGI_PRICE_LISTS_INDEX: 831,
  LOGI_PRICE_LISTS_MASSIVE_UPDATE: 1112,
  LOGI_PRICE_LISTS_PURGE: 830,
  LOGI_PRICE_LISTS_RESTORE: 829,
  LOGI_PRICE_LISTS_SHOW: 833,
  LOGI_PRICE_LISTS_STORE: 832,
  LOGI_PRICE_LISTS_UPDATE: 834,
  LOGI_PRICES: 818,
  LOGI_PRICES_APPROVE_RETAINED: 31290,
  LOGI_PRICES_DELETED: 819,
  LOGI_PRICES_DESTROY: 826,
  LOGI_PRICES_IGV_INDEX: 1111,
  LOGI_PRICES_INDEX: 822,
  LOGI_PRICES_PURGE: 821,
  LOGI_PRICES_RESTORE: 820,
  LOGI_PRICES_SHOW: 824,
  LOGI_PRICES_STORE: 823,
  LOGI_PRICES_UPDATE: 825,
  LOGI_PRODUCT_DISCOUNT_SCALES: 845,
  LOGI_PRODUCT_DISCOUNT_SCALES_DELETED: 846,
  LOGI_PRODUCT_DISCOUNT_SCALES_DESTROY: 853,
  LOGI_PRODUCT_DISCOUNT_SCALES_INDEX: 849,
  LOGI_PRODUCT_DISCOUNT_SCALES_PURGE: 848,
  LOGI_PRODUCT_DISCOUNT_SCALES_RESTORE: 847,
  LOGI_PRODUCT_DISCOUNT_SCALES_SHOW: 851,
  LOGI_PRODUCT_DISCOUNT_SCALES_STORE: 850,
  LOGI_PRODUCT_DISCOUNT_SCALES_UPDATE: 852,
  LOGI_PRODUCT_GROUPS: 854,
  LOGI_PRODUCT_GROUPS_DELETED: 855,
  LOGI_PRODUCT_GROUPS_DESTROY: 862,
  LOGI_PRODUCT_GROUPS_INDEX: 858,
  LOGI_PRODUCT_GROUPS_PURGE: 857,
  LOGI_PRODUCT_GROUPS_RESTORE: 856,
  LOGI_PRODUCT_GROUPS_SHOW: 860,
  LOGI_PRODUCT_GROUPS_STORE: 859,
  LOGI_PRODUCT_GROUPS_UPDATE: 861,
  LOGI_PRODUCTS: 836,
  LOGI_PRODUCTS_DELETED: 837,
  LOGI_PRODUCTS_DESTROY: 844,
  LOGI_PRODUCTS_INDEX: 840,
  LOGI_PRODUCTS_INVENTORY_SHOW: 1119,
  LOGI_PRODUCTS_INVENTORY_UPDATE: 1120,
  LOGI_PRODUCTS_OTHER_SHOW: 1121,
  LOGI_PRODUCTS_OTHER_UPDATE: 1122,
  LOGI_PRODUCTS_PURCHASE_DATA_SHOW: 1115,
  LOGI_PRODUCTS_PURCHASE_DATA_UPDATE: 1116,
  LOGI_PRODUCTS_PURCHASE_DATA_UPDATE_LAST_PURCHASE_PRICE: 31252,
  LOGI_PRODUCTS_PURGE: 839,
  LOGI_PRODUCTS_RESTORE: 838,
  LOGI_PRODUCTS_SALE_DATA_SHOW: 11147,
  LOGI_PRODUCTS_SALE_DATA_UPDATE: 11148,
  LOGI_PRODUCTS_SHOW: 842,
  LOGI_PRODUCTS_STORE: 841,
  LOGI_PRODUCTS_SUMMARY_SHOW: 1113,
  LOGI_PRODUCTS_SUMMARY_UPDATE: 1114,
  LOGI_PRODUCTS_TAX_SHOW: 1117,
  LOGI_PRODUCTS_TAX_UPDATE: 1118,
  LOGI_PRODUCTS_UPDATE: 843,
  LOGI_RULE_DISCOUNTS: 31399,
  LOGI_RULE_DISCOUNTS_DELETED: 31400,
  LOGI_RULE_DISCOUNTS_DESTROY: 31407,
  LOGI_RULE_DISCOUNTS_INDEX: 31403,
  LOGI_RULE_DISCOUNTS_PURGE: 31402,
  LOGI_RULE_DISCOUNTS_RESTORE: 31401,
  LOGI_RULE_DISCOUNTS_SHOW: 31405,
  LOGI_RULE_DISCOUNTS_STORE: 31404,
  LOGI_RULE_DISCOUNTS_UPDATE: 31406,
  LOGI_STOCKS: 863,
  LOGI_STOCKS_DELETED: 864,
  LOGI_STOCKS_DESTROY: 871,
  LOGI_STOCKS_INDEX: 867,
  LOGI_STOCKS_PURGE: 866,
  LOGI_STOCKS_RESTORE: 865,
  LOGI_STOCKS_REVALUATE: 31288,
  LOGI_STOCKS_SHOW: 869,
  LOGI_STOCKS_STORE: 868,
  LOGI_STOCKS_UPDATE: 870,
  LOGI_SUB_FAMILIES: 872,
  LOGI_SUB_FAMILIES_DELETED: 873,
  LOGI_SUB_FAMILIES_DESTROY: 880,
  LOGI_SUB_FAMILIES_INDEX: 876,
  LOGI_SUB_FAMILIES_PURGE: 875,
  LOGI_SUB_FAMILIES_RESTORE: 874,
  LOGI_SUB_FAMILIES_SHOW: 878,
  LOGI_SUB_FAMILIES_STORE: 877,
  LOGI_SUB_FAMILIES_UPDATE: 879,
  LOGI_TRANSFERS: 31228,
  LOGI_TRANSFERS_CONFIRM: 31237,
  LOGI_TRANSFERS_DELETED: 31229,
  LOGI_TRANSFERS_DESTROY: 31236,
  LOGI_TRANSFERS_INDEX: 31232,
  LOGI_TRANSFERS_PURGE: 31231,
  LOGI_TRANSFERS_RESTORE: 31230,
  LOGI_TRANSFERS_SHOW: 31234,
  LOGI_TRANSFERS_STORE: 31233,
  LOGI_TRANSFERS_UPDATE: 31235,
  LOGI_WAREHOUSES: 881,
  LOGI_WAREHOUSES_DELETED: 882,
  LOGI_WAREHOUSES_DESTROY: 889,
  LOGI_WAREHOUSES_INDEX: 885,
  LOGI_WAREHOUSES_PURGE: 884,
  LOGI_WAREHOUSES_RESTORE: 883,
  LOGI_WAREHOUSES_SHOW: 887,
  LOGI_WAREHOUSES_STORE: 886,
  LOGI_WAREHOUSES_UPDATE: 888,
  OAUTH_PERMISSIONS: 323,
  OAUTH_PERMISSIONS_DELETED: 324,
  OAUTH_PERMISSIONS_DESTROY: 331,
  OAUTH_PERMISSIONS_INDEX: 327,
  OAUTH_PERMISSIONS_PURGE: 326,
  OAUTH_PERMISSIONS_RESTORE: 325,
  OAUTH_PERMISSIONS_SHOW: 329,
  OAUTH_PERMISSIONS_STORE: 328,
  OAUTH_PERMISSIONS_UPDATE: 330,
  OAUTH_ROLES: 332,
  OAUTH_ROLES_DELETED: 333,
  OAUTH_ROLES_DESTROY: 340,
  OAUTH_ROLES_INDEX: 336,
  OAUTH_ROLES_PURGE: 335,
  OAUTH_ROLES_RESTORE: 334,
  OAUTH_ROLES_SHOW: 338,
  OAUTH_ROLES_STORE: 337,
  OAUTH_ROLES_UPDATE: 339,
  OAUTH_USERS: 1007,
  OAUTH_USERS_DELETED: 1008,
  OAUTH_USERS_DESTROY: 1015,
  OAUTH_USERS_INDEX: 1011,
  OAUTH_USERS_PURGE: 1010,
  OAUTH_USERS_RESTORE: 1009,
  OAUTH_USERS_SHOW: 1013,
  OAUTH_USERS_STORE: 1012,
  OAUTH_USERS_UPDATE: 1014,
  ORDM_CLOSING_WORK_DAYS: 31249,
  ORDM_CLOSING_WORK_DAYS_INDEX: 31250,
  ORDM_CLOSING_WORK_DAYS_UPDATE: 31251,
  ORDM_CUSTOMERS: 503,
  ORDM_CUSTOMERS_ANNULAR: 21138,
  ORDM_CUSTOMERS_APPROVE: 21137,
  ORDM_CUSTOMERS_DELETED: 504,
  ORDM_CUSTOMERS_DESTROY: 511,
  ORDM_CUSTOMERS_INDEX: 507,
  ORDM_CUSTOMERS_PURGE: 506,
  ORDM_CUSTOMERS_RESTORE: 505,
  ORDM_CUSTOMERS_SHOW: 509,
  ORDM_CUSTOMERS_STORE: 508,
  ORDM_CUSTOMERS_UPDATE: 510,
  ORDM_DETAIL_DISCOUNTS: 710,
  ORDM_DETAIL_DISCOUNTS_DELETED: 711,
  ORDM_DETAIL_DISCOUNTS_DESTROY: 718,
  ORDM_DETAIL_DISCOUNTS_INDEX: 714,
  ORDM_DETAIL_DISCOUNTS_PURGE: 713,
  ORDM_DETAIL_DISCOUNTS_RESTORE: 712,
  ORDM_DETAIL_DISCOUNTS_SHOW: 716,
  ORDM_DETAIL_DISCOUNTS_STORE: 715,
  ORDM_DETAIL_DISCOUNTS_UPDATE: 717,
  ORDM_GPS: 512,
  ORDM_GPS_DELETED: 513,
  ORDM_GPS_DESTROY: 520,
  ORDM_GPS_INDEX: 516,
  ORDM_GPS_PURGE: 515,
  ORDM_GPS_RESTORE: 514,
  ORDM_GPS_SHOW: 518,
  ORDM_GPS_STORE: 517,
  ORDM_GPS_UPDATE: 519,
  ORDM_ORDER_DETAILS: 530,
  ORDM_ORDER_DETAILS_DELETED: 531,
  ORDM_ORDER_DETAILS_DESTROY: 538,
  ORDM_ORDER_DETAILS_INDEX: 534,
  ORDM_ORDER_DETAILS_PURGE: 533,
  ORDM_ORDER_DETAILS_RESTORE: 532,
  ORDM_ORDER_DETAILS_SHOW: 536,
  ORDM_ORDER_DETAILS_STORE: 535,
  ORDM_ORDER_DETAILS_UPDATE: 537,
  ORDM_ORDERS: 521,
  ORDM_ORDERS_ANNULAR_COMMITED_ORDER: 31244,
  ORDM_ORDERS_ANNULAR_RETAINED_ORDER: 1089,
  ORDM_ORDERS_APPROVE_COMMITED_ORDER: 31243,
  ORDM_ORDERS_APPROVE_RETAINED_ORDER: 1088,
  ORDM_ORDERS_DELETED: 522,
  ORDM_ORDERS_DESTROY: 529,
  ORDM_ORDERS_INDEX: 525,
  ORDM_ORDERS_NO_ORDER: 1086,
  ORDM_ORDERS_PURGE: 524,
  ORDM_ORDERS_RESTORE: 523,
  ORDM_ORDERS_SHOW: 527,
  ORDM_ORDERS_STORE: 526,
  ORDM_ORDERS_STORE_WEB: 11135,
  ORDM_ORDERS_UPDATE: 528,
  ORDM_ORDERS_UPDATE_PACKAGE_PRICE: 31265,
  ORDM_ORDERS_VALIDATOR_ORDER: 1087,
  ORDM_REFUND_DETAILS: 548,
  ORDM_REFUND_DETAILS_DELETED: 549,
  ORDM_REFUND_DETAILS_DESTROY: 556,
  ORDM_REFUND_DETAILS_INDEX: 552,
  ORDM_REFUND_DETAILS_PURGE: 551,
  ORDM_REFUND_DETAILS_RESTORE: 550,
  ORDM_REFUND_DETAILS_SHOW: 554,
  ORDM_REFUND_DETAILS_STORE: 553,
  ORDM_REFUND_DETAILS_UPDATE: 555,
  ORDM_REFUNDS: 539,
  ORDM_REFUNDS_DELETED: 540,
  ORDM_REFUNDS_DESTROY: 547,
  ORDM_REFUNDS_INDEX: 543,
  ORDM_REFUNDS_PURGE: 542,
  ORDM_REFUNDS_RESTORE: 541,
  ORDM_REFUNDS_SHOW: 545,
  ORDM_REFUNDS_STORE: 544,
  ORDM_REFUNDS_UPDATE: 546,
  ORDM_WORK_DAYS: 557,
  ORDM_WORK_DAYS_DELETED: 558,
  ORDM_WORK_DAYS_DESTROY: 565,
  ORDM_WORK_DAYS_INDEX: 561,
  ORDM_WORK_DAYS_PURGE: 560,
  ORDM_WORK_DAYS_RESTORE: 559,
  ORDM_WORK_DAYS_SHOW: 563,
  ORDM_WORK_DAYS_STORE: 562,
  ORDM_WORK_DAYS_UPDATE: 564,
  PROG_DIFFERENCES: 593,
  PROG_DIFFERENCES_DELETED: 594,
  PROG_DIFFERENCES_DESTROY: 601,
  PROG_DIFFERENCES_INDEX: 597,
  PROG_DIFFERENCES_PURGE: 596,
  PROG_DIFFERENCES_RESTORE: 595,
  PROG_DIFFERENCES_SHOW: 599,
  PROG_DIFFERENCES_STORE: 598,
  PROG_DIFFERENCES_UPDATE: 600,
  PROG_DISTRIBUTION_STAFF: 602,
  PROG_DISTRIBUTION_STAFF_DELETED: 603,
  PROG_DISTRIBUTION_STAFF_DESTROY: 610,
  PROG_DISTRIBUTION_STAFF_INDEX: 606,
  PROG_DISTRIBUTION_STAFF_PURGE: 605,
  PROG_DISTRIBUTION_STAFF_RESTORE: 604,
  PROG_DISTRIBUTION_STAFF_SHOW: 608,
  PROG_DISTRIBUTION_STAFF_STORE: 607,
  PROG_DISTRIBUTION_STAFF_UPDATE: 609,
  PROG_SHEET_DISTRIBUTION_DETAILS: 1135,
  PROG_SHEET_DISTRIBUTION_DETAILS_DELETED: 1136,
  PROG_SHEET_DISTRIBUTION_DETAILS_DESTROY: 1143,
  PROG_SHEET_DISTRIBUTION_DETAILS_INDEX: 1139,
  PROG_SHEET_DISTRIBUTION_DETAILS_PURGE: 1138,
  PROG_SHEET_DISTRIBUTION_DETAILS_RESTORE: 1137,
  PROG_SHEET_DISTRIBUTION_DETAILS_SHOW: 1141,
  PROG_SHEET_DISTRIBUTION_DETAILS_STORE: 1140,
  PROG_SHEET_DISTRIBUTION_DETAILS_UPDATE: 1142,
  PROG_SHEET_DISTRIBUTIONS: 611,
  PROG_SHEET_DISTRIBUTIONS_ANNULAR_SAP: 31264,
  PROG_SHEET_DISTRIBUTIONS_BULK_INSERT: 1095,
  PROG_SHEET_DISTRIBUTIONS_CHANGE_STATE: 1097,
  PROG_SHEET_DISTRIBUTIONS_CONSOLIDATED: 1096,
  PROG_SHEET_DISTRIBUTIONS_DELETED: 612,
  PROG_SHEET_DISTRIBUTIONS_DESTROY: 619,
  PROG_SHEET_DISTRIBUTIONS_DETAILS: 620,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_DELETED: 621,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_DESTROY: 628,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_INDEX: 624,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_PURGE: 623,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_RESTORE: 622,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_SHOW: 626,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_STORE: 625,
  PROG_SHEET_DISTRIBUTIONS_DETAILS_UPDATE: 627,
  PROG_SHEET_DISTRIBUTIONS_INDEX: 615,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION: 1098,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_INDEX: 1104,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_SAVE: 1106,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_COMMODITY_SHOW: 1105,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_CHANGE_STATE: 1102,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_EXCLUDED: 31166,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_INDEX: 1101,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_DOCUMENT_SHOW_LIQUIDATED: 1103,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_INDEX: 1099,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_LEFT_OVERS_INDEX: 1107,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_LEFT_OVERS_PRINT: 1108,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_LIQUIDATE: 11136,
  PROG_SHEET_DISTRIBUTIONS_LIQUIDATION_SHOW: 1100,
  PROG_SHEET_DISTRIBUTIONS_OPEN_VALIDATE_BP: 31238,
  PROG_SHEET_DISTRIBUTIONS_PURGE: 614,
  PROG_SHEET_DISTRIBUTIONS_RESTORE: 613,
  PROG_SHEET_DISTRIBUTIONS_SHOW: 617,
  PROG_SHEET_DISTRIBUTIONS_STORE: 616,
  PROG_SHEET_DISTRIBUTIONS_UNCONFIRM: 31266,
  PROG_SHEET_DISTRIBUTIONS_UPDATE: 618,
  PROG_SHEET_DOCUMENT: 665,
  PROG_SHEET_DOCUMENT_DELETED: 666,
  PROG_SHEET_DOCUMENT_DESTROY: 673,
  PROG_SHEET_DOCUMENT_INDEX: 669,
  PROG_SHEET_DOCUMENT_LINES: 638,
  PROG_SHEET_DOCUMENT_LINES_DELETED: 639,
  PROG_SHEET_DOCUMENT_LINES_DESTROY: 646,
  PROG_SHEET_DOCUMENT_LINES_INDEX: 642,
  PROG_SHEET_DOCUMENT_LINES_PURGE: 641,
  PROG_SHEET_DOCUMENT_LINES_RESTORE: 640,
  PROG_SHEET_DOCUMENT_LINES_SHOW: 644,
  PROG_SHEET_DOCUMENT_LINES_STORE: 643,
  PROG_SHEET_DOCUMENT_LINES_UPDATE: 645,
  PROG_SHEET_DOCUMENT_PURGE: 668,
  PROG_SHEET_DOCUMENT_RESTORE: 667,
  PROG_SHEET_DOCUMENT_SHOW: 671,
  PROG_SHEET_DOCUMENT_STORE: 670,
  PROG_SHEET_DOCUMENT_UPDATE: 672,
  PROG_SHEET_DOCUMENTS: 629,
  PROG_SHEET_DOCUMENTS_DELETED: 630,
  PROG_SHEET_DOCUMENTS_DESTROY: 637,
  PROG_SHEET_DOCUMENTS_INDEX: 633,
  PROG_SHEET_DOCUMENTS_PURGE: 632,
  PROG_SHEET_DOCUMENTS_RESTORE: 631,
  PROG_SHEET_DOCUMENTS_SHOW: 635,
  PROG_SHEET_DOCUMENTS_STORE: 634,
  PROG_SHEET_DOCUMENTS_UPDATE: 636,
  PROG_SHEET_LOADS: 647,
  PROG_SHEET_LOADS_DELETED: 648,
  PROG_SHEET_LOADS_DESTROY: 655,
  PROG_SHEET_LOADS_INDEX: 651,
  PROG_SHEET_LOADS_PURGE: 650,
  PROG_SHEET_LOADS_RESTORE: 649,
  PROG_SHEET_LOADS_SHOW: 653,
  PROG_SHEET_LOADS_STORE: 652,
  PROG_SHEET_LOADS_UPDATE: 654,
  PROG_VEHICLES: 656,
  PROG_VEHICLES_DELETED: 657,
  PROG_VEHICLES_DESTROY: 664,
  PROG_VEHICLES_INDEX: 660,
  PROG_VEHICLES_PURGE: 659,
  PROG_VEHICLES_RESTORE: 658,
  PROG_VEHICLES_SHOW: 662,
  PROG_VEHICLES_STORE: 661,
  PROG_VEHICLES_UPDATE: 663,
  PROG_ZONE_OPENS: 31190,
  PROG_ZONE_OPENS_DELETED: 31191,
  PROG_ZONE_OPENS_DESTROY: 31198,
  PROG_ZONE_OPENS_INDEX: 31194,
  PROG_ZONE_OPENS_PURGE: 31193,
  PROG_ZONE_OPENS_RESTORE: 31192,
  PROG_ZONE_OPENS_SHOW: 31196,
  PROG_ZONE_OPENS_STORE: 31195,
  PROG_ZONE_OPENS_UPDATE: 31197,
  PROM_BONIFICATION_GROUPS: 350,
  PROM_BONIFICATION_GROUPS_DELETED: 351,
  PROM_BONIFICATION_GROUPS_DESTROY: 358,
  PROM_BONIFICATION_GROUPS_INDEX: 354,
  PROM_BONIFICATION_GROUPS_PURGE: 353,
  PROM_BONIFICATION_GROUPS_RESTORE: 352,
  PROM_BONIFICATION_GROUPS_SHOW: 356,
  PROM_BONIFICATION_GROUPS_STORE: 355,
  PROM_BONIFICATION_GROUPS_UPDATE: 357,
  PROM_BONIFICATION_PRODUCTS: 359,
  PROM_BONIFICATION_PRODUCTS_DELETED: 360,
  PROM_BONIFICATION_PRODUCTS_DESTROY: 367,
  PROM_BONIFICATION_PRODUCTS_INDEX: 363,
  PROM_BONIFICATION_PRODUCTS_PURGE: 362,
  PROM_BONIFICATION_PRODUCTS_RESTORE: 361,
  PROM_BONIFICATION_PRODUCTS_SHOW: 365,
  PROM_BONIFICATION_PRODUCTS_STORE: 364,
  PROM_BONIFICATION_PRODUCTS_UPDATE: 366,
  PROM_BONIFICATIONS: 341,
  PROM_BONIFICATIONS_DELETED: 342,
  PROM_BONIFICATIONS_DESTROY: 349,
  PROM_BONIFICATIONS_INDEX: 345,
  PROM_BONIFICATIONS_PURGE: 344,
  PROM_BONIFICATIONS_RESTORE: 343,
  PROM_BONIFICATIONS_SHOW: 347,
  PROM_BONIFICATIONS_STORE: 346,
  PROM_BONIFICATIONS_UPDATE: 348,
  PROM_CUSTOMER_COUNTERS: 377,
  PROM_CUSTOMER_COUNTERS_DELETED: 378,
  PROM_CUSTOMER_COUNTERS_DESTROY: 385,
  PROM_CUSTOMER_COUNTERS_INDEX: 381,
  PROM_CUSTOMER_COUNTERS_PURGE: 380,
  PROM_CUSTOMER_COUNTERS_RESTORE: 379,
  PROM_CUSTOMER_COUNTERS_SHOW: 383,
  PROM_CUSTOMER_COUNTERS_STORE: 382,
  PROM_CUSTOMER_COUNTERS_UPDATE: 384,
  PROM_CUSTOMER_GROUPS: 386,
  PROM_CUSTOMER_GROUPS_DELETED: 387,
  PROM_CUSTOMER_GROUPS_DESTROY: 394,
  PROM_CUSTOMER_GROUPS_INDEX: 390,
  PROM_CUSTOMER_GROUPS_PURGE: 389,
  PROM_CUSTOMER_GROUPS_RESTORE: 388,
  PROM_CUSTOMER_GROUPS_SHOW: 392,
  PROM_CUSTOMER_GROUPS_STORE: 391,
  PROM_CUSTOMER_GROUPS_UPDATE: 393,
  PROM_CUSTOMER_TEMPORALS: 395,
  PROM_CUSTOMER_TEMPORALS_DELETED: 396,
  PROM_CUSTOMER_TEMPORALS_DESTROY: 403,
  PROM_CUSTOMER_TEMPORALS_INDEX: 399,
  PROM_CUSTOMER_TEMPORALS_PURGE: 398,
  PROM_CUSTOMER_TEMPORALS_RESTORE: 397,
  PROM_CUSTOMER_TEMPORALS_SHOW: 401,
  PROM_CUSTOMER_TEMPORALS_STORE: 400,
  PROM_CUSTOMER_TEMPORALS_UPDATE: 402,
  PROM_CUSTOMERS: 368,
  PROM_CUSTOMERS_DELETED: 369,
  PROM_CUSTOMERS_DESTROY: 376,
  PROM_CUSTOMERS_INDEX: 372,
  PROM_CUSTOMERS_PURGE: 371,
  PROM_CUSTOMERS_RESTORE: 370,
  PROM_CUSTOMERS_SHOW: 374,
  PROM_CUSTOMERS_STORE: 373,
  PROM_CUSTOMERS_UPDATE: 375,
  PROM_PRODUCT_ACCOUNTANTS: 413,
  PROM_PRODUCT_ACCOUNTANTS_DELETED: 414,
  PROM_PRODUCT_ACCOUNTANTS_DESTROY: 421,
  PROM_PRODUCT_ACCOUNTANTS_INDEX: 417,
  PROM_PRODUCT_ACCOUNTANTS_PURGE: 416,
  PROM_PRODUCT_ACCOUNTANTS_RESTORE: 415,
  PROM_PRODUCT_ACCOUNTANTS_SHOW: 419,
  PROM_PRODUCT_ACCOUNTANTS_STORE: 418,
  PROM_PRODUCT_ACCOUNTANTS_UPDATE: 420,
  PROM_PRODUCT_GROUPS: 422,
  PROM_PRODUCT_GROUPS_DELETED: 423,
  PROM_PRODUCT_GROUPS_DESTROY: 430,
  PROM_PRODUCT_GROUPS_INDEX: 426,
  PROM_PRODUCT_GROUPS_PURGE: 425,
  PROM_PRODUCT_GROUPS_RESTORE: 424,
  PROM_PRODUCT_GROUPS_SHOW: 428,
  PROM_PRODUCT_GROUPS_STORE: 427,
  PROM_PRODUCT_GROUPS_UPDATE: 429,
  PROM_PRODUCTS: 404,
  PROM_PRODUCTS_DELETED: 405,
  PROM_PRODUCTS_DESTROY: 412,
  PROM_PRODUCTS_INDEX: 408,
  PROM_PRODUCTS_PURGE: 407,
  PROM_PRODUCTS_RESTORE: 406,
  PROM_PRODUCTS_SHOW: 410,
  PROM_PRODUCTS_STORE: 409,
  PROM_PRODUCTS_UPDATE: 411,
  PROM_PROMOTIONS: 431,
  PROM_PROMOTIONS_APPROVE_RETAINED: 31306,
  PROM_PROMOTIONS_DELETE_BONIFICATION_GROUPS: 1084,
  PROM_PROMOTIONS_DELETE_SELL_GROUPS: 1083,
  PROM_PROMOTIONS_DELETED: 432,
  PROM_PROMOTIONS_DESTROY: 439,
  PROM_PROMOTIONS_INDEX: 435,
  PROM_PROMOTIONS_PURGE: 434,
  PROM_PROMOTIONS_RESTORE: 433,
  PROM_PROMOTIONS_SAP: 440,
  PROM_PROMOTIONS_SAP_DELETED: 441,
  PROM_PROMOTIONS_SAP_DESTROY: 448,
  PROM_PROMOTIONS_SAP_INDEX: 444,
  PROM_PROMOTIONS_SAP_PURGE: 443,
  PROM_PROMOTIONS_SAP_RESTORE: 442,
  PROM_PROMOTIONS_SAP_SHOW: 446,
  PROM_PROMOTIONS_SAP_STORE: 445,
  PROM_PROMOTIONS_SAP_UPDATE: 447,
  PROM_PROMOTIONS_SHOW: 437,
  PROM_PROMOTIONS_STORE: 436,
  PROM_PROMOTIONS_UPDATE: 438,
  PROM_PROMOTIONS_VALIDATE_PROVIDER: 1085,
  PROM_RESTRICTIONS: 449,
  PROM_RESTRICTIONS_DELETED: 450,
  PROM_RESTRICTIONS_DESTROY: 457,
  PROM_RESTRICTIONS_INDEX: 453,
  PROM_RESTRICTIONS_PURGE: 452,
  PROM_RESTRICTIONS_RESTORE: 451,
  PROM_RESTRICTIONS_SHOW: 455,
  PROM_RESTRICTIONS_STORE: 454,
  PROM_RESTRICTIONS_UPDATE: 456,
  PROM_RESULT2S: 467,
  PROM_RESULT2S_DELETED: 468,
  PROM_RESULT2S_DESTROY: 475,
  PROM_RESULT2S_INDEX: 471,
  PROM_RESULT2S_PURGE: 470,
  PROM_RESULT2S_RESTORE: 469,
  PROM_RESULT2S_SHOW: 473,
  PROM_RESULT2S_STORE: 472,
  PROM_RESULT2S_UPDATE: 474,
  PROM_RESULTS: 458,
  PROM_RESULTS_DELETED: 459,
  PROM_RESULTS_DESTROY: 466,
  PROM_RESULTS_INDEX: 462,
  PROM_RESULTS_PURGE: 461,
  PROM_RESULTS_RESTORE: 460,
  PROM_RESULTS_SHOW: 464,
  PROM_RESULTS_STORE: 463,
  PROM_RESULTS_UPDATE: 465,
  PROM_RULES: 476,
  PROM_RULES_DELETED: 477,
  PROM_RULES_DESTROY: 484,
  PROM_RULES_INDEX: 480,
  PROM_RULES_PURGE: 479,
  PROM_RULES_RESTORE: 478,
  PROM_RULES_SHOW: 482,
  PROM_RULES_STORE: 481,
  PROM_RULES_UPDATE: 483,
  PROM_TABLE_STATES: 485,
  PROM_TABLE_STATES_DELETED: 486,
  PROM_TABLE_STATES_DESTROY: 493,
  PROM_TABLE_STATES_INDEX: 489,
  PROM_TABLE_STATES_PURGE: 488,
  PROM_TABLE_STATES_RESTORE: 487,
  PROM_TABLE_STATES_SHOW: 491,
  PROM_TABLE_STATES_STORE: 490,
  PROM_TABLE_STATES_UPDATE: 492,
  PROM_VALIDATED_RESULTS: 494,
  PROM_VALIDATED_RESULTS_DELETED: 495,
  PROM_VALIDATED_RESULTS_DESTROY: 502,
  PROM_VALIDATED_RESULTS_INDEX: 498,
  PROM_VALIDATED_RESULTS_PURGE: 497,
  PROM_VALIDATED_RESULTS_RESTORE: 496,
  PROM_VALIDATED_RESULTS_SHOW: 500,
  PROM_VALIDATED_RESULTS_STORE: 499,
  PROM_VALIDATED_RESULTS_UPDATE: 501,
  PRT_DOCUMENT_PERMISSIONS: 944,
  PRT_DOCUMENT_PERMISSIONS_DELETED: 945,
  PRT_DOCUMENT_PERMISSIONS_DESTROY: 952,
  PRT_DOCUMENT_PERMISSIONS_INDEX: 948,
  PRT_DOCUMENT_PERMISSIONS_PURGE: 947,
  PRT_DOCUMENT_PERMISSIONS_RESTORE: 946,
  PRT_DOCUMENT_PERMISSIONS_SHOW: 950,
  PRT_DOCUMENT_PERMISSIONS_STORE: 949,
  PRT_DOCUMENT_PERMISSIONS_UPDATE: 951,
  PRT_DOCUMENT_SERIE_PERMISSIONS: 953,
  PRT_DOCUMENT_SERIE_PERMISSIONS_DELETED: 954,
  PRT_DOCUMENT_SERIE_PERMISSIONS_DESTROY: 961,
  PRT_DOCUMENT_SERIE_PERMISSIONS_INDEX: 957,
  PRT_DOCUMENT_SERIE_PERMISSIONS_PURGE: 956,
  PRT_DOCUMENT_SERIE_PERMISSIONS_RESTORE: 955,
  PRT_DOCUMENT_SERIE_PERMISSIONS_SHOW: 959,
  PRT_DOCUMENT_SERIE_PERMISSIONS_STORE: 958,
  PRT_DOCUMENT_SERIE_PERMISSIONS_UPDATE: 960,
  PRT_DOCUMENTS: 935,
  PRT_DOCUMENTS_DELETED: 936,
  PRT_DOCUMENTS_DESTROY: 943,
  PRT_DOCUMENTS_INDEX: 939,
  PRT_DOCUMENTS_PURGE: 938,
  PRT_DOCUMENTS_RESTORE: 937,
  PRT_DOCUMENTS_SHOW: 941,
  PRT_DOCUMENTS_STORE: 940,
  PRT_DOCUMENTS_UPDATE: 942,
  PRT_GUIDE_SERIES: 31245,
  PRT_GUIDE_SERIES_INDEX: 31246,
  PRT_GUIDE_SERIES_SHOW: 31248,
  PRT_GUIDE_SERIES_STORE: 31247,
  PURCH_PURCHASE_DETAILS: 971,
  PURCH_PURCHASE_DETAILS_DELETED: 972,
  PURCH_PURCHASE_DETAILS_DESTROY: 979,
  PURCH_PURCHASE_DETAILS_INDEX: 975,
  PURCH_PURCHASE_DETAILS_PURGE: 974,
  PURCH_PURCHASE_DETAILS_RESTORE: 973,
  PURCH_PURCHASE_DETAILS_SHOW: 977,
  PURCH_PURCHASE_DETAILS_STORE: 976,
  PURCH_PURCHASE_DETAILS_UPDATE: 978,
  PURCH_PURCHASES: 962,
  PURCH_PURCHASES_BOSSLOGISTIC_INDEX: 31331,
  PURCH_PURCHASES_DELETED: 963,
  PURCH_PURCHASES_DESTROY: 970,
  PURCH_PURCHASES_DOCUMENT_INDEX: 31259,
  PURCH_PURCHASES_DOWNLOAD_FILE: 1125,
  PURCH_PURCHASES_GET_FILE: 1124,
  PURCH_PURCHASES_HEADER_SHOW: 1126,
  PURCH_PURCHASES_HEADER_VALIDATE: 1127,
  PURCH_PURCHASES_INDEX: 966,
  PURCH_PURCHASES_INVOICE_DETAIL_ADD: 1130,
  PURCH_PURCHASES_INVOICE_DETAIL_SHOW: 1129,
  PURCH_PURCHASES_INVOICE_SHOW: 1128,
  PURCH_PURCHASES_LOG_SHOW: 1131,
  PURCH_PURCHASES_LOGIN: 1123,
  PURCH_PURCHASES_MERCHANDISE_INDEX: 31344,
  PURCH_PURCHASES_NO_VALIDATE_PRICES: 31267,
  PURCH_PURCHASES_PDF_SHOW: 1132,
  PURCH_PURCHASES_PROVIDER_INDEX: 31258,
  PURCH_PURCHASES_PURGE: 965,
  PURCH_PURCHASES_RESTORE: 964,
  PURCH_PURCHASES_SHOW: 968,
  PURCH_PURCHASES_STORE: 967,
  PURCH_PURCHASES_SUPERVISOR_INDEX: 31330,
  PURCH_PURCHASES_UPDATE: 969,
  PURCH_PURCHASES_XML_DOWNLOAD: 1134,
  PURCH_PURCHASES_XML_SHOW: 1133,
  PURCH_ROUNDINGS: 980,
  PURCH_ROUNDINGS_DELETED: 981,
  PURCH_ROUNDINGS_DESTROY: 988,
  PURCH_ROUNDINGS_INDEX: 984,
  PURCH_ROUNDINGS_PURGE: 983,
  PURCH_ROUNDINGS_RESTORE: 982,
  PURCH_ROUNDINGS_SHOW: 986,
  PURCH_ROUNDINGS_STORE: 985,
  PURCH_ROUNDINGS_UPDATE: 987,
  PURCH_SIRE_CONCILIATIONS: 31390,
  PURCH_SIRE_CONCILIATIONS_DELETED: 31391,
  PURCH_SIRE_CONCILIATIONS_DESTROY: 31398,
  PURCH_SIRE_CONCILIATIONS_INDEX: 31394,
  PURCH_SIRE_CONCILIATIONS_PURGE: 31393,
  PURCH_SIRE_CONCILIATIONS_RESTORE: 31392,
  PURCH_SIRE_CONCILIATIONS_SHOW: 31396,
  PURCH_SIRE_CONCILIATIONS_STORE: 31395,
  PURCH_SIRE_CONCILIATIONS_UPDATE: 31397,
  PURCH_TAXES: 989,
  PURCH_TAXES_DELETED: 990,
  PURCH_TAXES_DESTROY: 997,
  PURCH_TAXES_INDEX: 993,
  PURCH_TAXES_PURGE: 992,
  PURCH_TAXES_RESTORE: 991,
  PURCH_TAXES_SHOW: 995,
  PURCH_TAXES_STORE: 994,
  PURCH_TAXES_UPDATE: 996,
  PYMT_ACCOMPLISHED_PAYMENTS: 1153,
  PYMT_ACCOMPLISHED_PAYMENTS_DELETED: 1154,
  PYMT_ACCOMPLISHED_PAYMENTS_DESTROY: 1161,
  PYMT_ACCOMPLISHED_PAYMENTS_DOCDATE: 31241,
  PYMT_ACCOMPLISHED_PAYMENTS_INDEX: 1157,
  PYMT_ACCOMPLISHED_PAYMENTS_PROVIDERS_MERCH_SUPPLIER: 31260,
  PYMT_ACCOMPLISHED_PAYMENTS_PROVIDERS_NOT_MERCH_SUPPLIER: 31261,
  PYMT_ACCOMPLISHED_PAYMENTS_PURGE: 1156,
  PYMT_ACCOMPLISHED_PAYMENTS_RESTORE: 1155,
  PYMT_ACCOMPLISHED_PAYMENTS_SHOW: 1159,
  PYMT_ACCOMPLISHED_PAYMENTS_STORE: 1158,
  PYMT_ACCOMPLISHED_PAYMENTS_UPDATE: 1160,
  PYMT_ACCOUNT_CONCEPTS: 21166,
  PYMT_ACCOUNT_CONCEPTS_DELETED: 21167,
  PYMT_ACCOUNT_CONCEPTS_DESTROY: 21173,
  PYMT_ACCOUNT_CONCEPTS_INDEX: 21170,
  PYMT_ACCOUNT_CONCEPTS_PURGE: 21169,
  PYMT_ACCOUNT_CONCEPTS_RESTORE: 21168,
  PYMT_ACCOUNT_CONCEPTS_SHOW: 21172,
  PYMT_ACCOUNT_CONCEPTS_STORE: 21171,
  PYMT_ACCOUNTS: 21139,
  PYMT_ACCOUNTS_DELETED: 21140,
  PYMT_ACCOUNTS_DESTROY: 21147,
  PYMT_ACCOUNTS_INDEX: 21143,
  PYMT_ACCOUNTS_PURGE: 21142,
  PYMT_ACCOUNTS_RESTORE: 21141,
  PYMT_ACCOUNTS_SHOW: 21145,
  PYMT_ACCOUNTS_STORE: 21144,
  PYMT_ACCOUNTS_UPDATE: 21146,
  PYMT_CLOSINGS: 31297,
  PYMT_CLOSINGS_CLOSE: 31308,
  PYMT_CLOSINGS_DELETED: 31298,
  PYMT_CLOSINGS_DESTROY: 31305,
  PYMT_CLOSINGS_INDEX: 31301,
  PYMT_CLOSINGS_OPEN: 31307,
  PYMT_CLOSINGS_PURGE: 31300,
  PYMT_CLOSINGS_REOPEN: 31309,
  PYMT_CLOSINGS_RESTORE: 31299,
  PYMT_CLOSINGS_SHOW: 31303,
  PYMT_CLOSINGS_STORE: 31302,
  PYMT_CLOSINGS_UPDATE: 31304,
  PYMT_CONCEPTS: 21148,
  PYMT_CONCEPTS_DELETED: 21149,
  PYMT_CONCEPTS_DESTROY: 21156,
  PYMT_CONCEPTS_INDEX: 21152,
  PYMT_CONCEPTS_PURGE: 21151,
  PYMT_CONCEPTS_RESTORE: 21150,
  PYMT_CONCEPTS_SHOW: 21154,
  PYMT_CONCEPTS_STORE: 21153,
  PYMT_CONCEPTS_UPDATE: 21155,
  PYMT_DEPOSITS: 31253,
  PYMT_DEPOSITS_DESTROY: 31257,
  PYMT_DEPOSITS_INDEX: 31254,
  PYMT_DEPOSITS_SHOW: 31256,
  PYMT_DEPOSITS_STORE: 31255,
  PYMT_EXPENSE_CENTERS: 21157,
  PYMT_EXPENSE_CENTERS_DELETED: 21158,
  PYMT_EXPENSE_CENTERS_DESTROY: 21165,
  PYMT_EXPENSE_CENTERS_INDEX: 21161,
  PYMT_EXPENSE_CENTERS_PURGE: 21160,
  PYMT_EXPENSE_CENTERS_RESTORE: 21159,
  PYMT_EXPENSE_CENTERS_SHOW: 21163,
  PYMT_EXPENSE_CENTERS_STORE: 21162,
  PYMT_EXPENSE_CENTERS_UPDATE: 21164,
  PYMT_RECEIVED_PAYMENTS: 1144,
  PYMT_RECEIVED_PAYMENTS_DELETED: 1145,
  PYMT_RECEIVED_PAYMENTS_DESTROY: 1152,
  PYMT_RECEIVED_PAYMENTS_DOCDATE: 31240,
  PYMT_RECEIVED_PAYMENTS_INDEX: 1148,
  PYMT_RECEIVED_PAYMENTS_MASSIVE_APPLY: 31289,
  PYMT_RECEIVED_PAYMENTS_PURGE: 1147,
  PYMT_RECEIVED_PAYMENTS_RESTORE: 1146,
  PYMT_RECEIVED_PAYMENTS_SHOW: 1150,
  PYMT_RECEIVED_PAYMENTS_STORE: 1149,
  PYMT_RECEIVED_PAYMENTS_UPDATE: 1151,
  REPORT_PROGRAM_ANALYSIS: 31363,
  REPORT_PROGRAM_ANALYSIS_DELETED: 31364,
  REPORT_PROGRAM_ANALYSIS_DESTROY: 31371,
  REPORT_PROGRAM_ANALYSIS_INDEX: 31367,
  REPORT_PROGRAM_ANALYSIS_PURGE: 31366,
  REPORT_PROGRAM_ANALYSIS_RESTORE: 31365,
  REPORT_PROGRAM_ANALYSIS_SHOW: 31369,
  REPORT_PROGRAM_ANALYSIS_STORE: 31368,
  REPORT_PROGRAM_ANALYSIS_UPDATE: 31370,
  REPORT_ROUTE_SALES: 31319,
  REPORT_ROUTE_SALES_INDEX: 31320,
  REPORT_SALES_EXCEL: 31345,
  REPORT_SALES_EXCEL_DELETED: 31346,
  REPORT_SALES_EXCEL_DESTROY: 31353,
  REPORT_SALES_EXCEL_INDEX: 31349,
  REPORT_SALES_EXCEL_PURGE: 31348,
  REPORT_SALES_EXCEL_RESTORE: 31347,
  REPORT_SALES_EXCEL_SHOW: 31351,
  REPORT_SALES_EXCEL_STORE: 31350,
  REPORT_SALES_EXCEL_UPDATE: 31352,
  REPORT_WHATSAPP: 31354,
  REPORT_WHATSAPP_DELETED: 31355,
  REPORT_WHATSAPP_DESTROY: 31362,
  REPORT_WHATSAPP_INDEX: 31358,
  REPORT_WHATSAPP_PURGE: 31357,
  REPORT_WHATSAPP_RESTORE: 31356,
  REPORT_WHATSAPP_SHOW: 31360,
  REPORT_WHATSAPP_STORE: 31359,
  REPORT_WHATSAPP_UPDATE: 31361,
  SALE_COMISIONES: 31332,
  SALE_COMISIONES_DELETED: 31333,
  SALE_COMISIONES_DESTROY: 31340,
  SALE_COMISIONES_INDEX: 31336,
  SALE_COMISIONES_PURGE: 31335,
  SALE_COMISIONES_RESTORE: 31334,
  SALE_COMISIONES_SHOW: 31338,
  SALE_COMISIONES_STORE: 31337,
  SALE_COMISIONES_UPDATE: 31339,
  SALE_CREDIT_NOTE_ANNULAR: 31171,
  SALE_CREDIT_NOTE_APPROVE_RETAINED: 31263,
  SALE_CREDIT_NOTE_DOCDATE: 31239,
  SALE_CREDIT_NOTE_INDEX: 31169,
  SALE_CREDIT_NOTE_STORE: 31170,
  SALE_CUSTOMER_PROVIDER_QUOTES: 31181,
  SALE_CUSTOMER_PROVIDER_QUOTES_DELETED: 31182,
  SALE_CUSTOMER_PROVIDER_QUOTES_DESTROY: 31189,
  SALE_CUSTOMER_PROVIDER_QUOTES_INDEX: 31185,
  SALE_CUSTOMER_PROVIDER_QUOTES_PURGE: 31184,
  SALE_CUSTOMER_PROVIDER_QUOTES_RESTORE: 31183,
  SALE_CUSTOMER_PROVIDER_QUOTES_SHOW: 31187,
  SALE_CUSTOMER_PROVIDER_QUOTES_STORE: 31186,
  SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE: 31188,
  SALE_DISCOUNTS: 566,
  SALE_DISCOUNTS_DELETED: 567,
  SALE_DISCOUNTS_DESTROY: 574,
  SALE_DISCOUNTS_INDEX: 570,
  SALE_DISCOUNTS_PURGE: 569,
  SALE_DISCOUNTS_RESTORE: 568,
  SALE_DISCOUNTS_SHOW: 572,
  SALE_DISCOUNTS_STORE: 571,
  SALE_DISCOUNTS_UPDATE: 573,
  SALE_ORDER_LINES: 584,
  SALE_ORDER_LINES_DELETED: 585,
  SALE_ORDER_LINES_DESTROY: 592,
  SALE_ORDER_LINES_INDEX: 588,
  SALE_ORDER_LINES_PURGE: 587,
  SALE_ORDER_LINES_RESTORE: 586,
  SALE_ORDER_LINES_SHOW: 590,
  SALE_ORDER_LINES_STORE: 589,
  SALE_ORDER_LINES_UPDATE: 591,
  SALE_ORDERS: 575,
  SALE_ORDERS_ANNULAR: 31242,
  SALE_ORDERS_ANNULAR_LIMITED: 31408,
  SALE_ORDERS_DELETED: 576,
  SALE_ORDERS_DESTROY: 583,
  SALE_ORDERS_HANDLE_RETAINED: 1090,
  SALE_ORDERS_HANDLE_RETAINED_ANNULLED: 1094,
  SALE_ORDERS_HANDLE_RETAINED_APPROVED: 1093,
  SALE_ORDERS_HANDLE_RETAINED_INDEX: 1091,
  SALE_ORDERS_HANDLE_RETAINED_SHOW: 1092,
  SALE_ORDERS_INDEX: 579,
  SALE_ORDERS_PURGE: 578,
  SALE_ORDERS_RESTORE: 577,
  SALE_ORDERS_SHOW: 581,
  SALE_ORDERS_STORE: 580,
  SALE_ORDERS_UPDATE: 582,
  SALE_ORDERS_WAREHOUSEAUDITOR_INDEX: 31341,
  SALE_SIRE_CONCILIATIONS: 31381,
  SALE_SIRE_CONCILIATIONS_DELETED: 31382,
  SALE_SIRE_CONCILIATIONS_DESTROY: 31389,
  SALE_SIRE_CONCILIATIONS_INDEX: 31385,
  SALE_SIRE_CONCILIATIONS_PURGE: 31384,
  SALE_SIRE_CONCILIATIONS_RESTORE: 31383,
  SALE_SIRE_CONCILIATIONS_SHOW: 31387,
  SALE_SIRE_CONCILIATIONS_STORE: 31386,
  SALE_SIRE_CONCILIATIONS_UPDATE: 31388,
  TRAITS_PERMISSION_TRAITS: 998,
  TRAITS_PERMISSION_TRAITS_DELETED: 999,
  TRAITS_PERMISSION_TRAITS_DESTROY: 1006,
  TRAITS_PERMISSION_TRAITS_INDEX: 1002,
  TRAITS_PERMISSION_TRAITS_PURGE: 1001,
  TRAITS_PERMISSION_TRAITS_RESTORE: 1000,
  TRAITS_PERMISSION_TRAITS_SHOW: 1004,
  TRAITS_PERMISSION_TRAITS_STORE: 1003,
  TRAITS_PERMISSION_TRAITS_UPDATE: 1005,
};

export { ConstantPermissions };

